export interface SegOption<T extends string> {
  value: T
  label: string
  count?: number
}

export interface SegProps<T extends string> {
  value: T
  options: SegOption<T>[]
  onChange: (value: T) => void
  name?: string
}

/**
 * Nocturne's .seg sets overflow:hidden, so it collapses if a flex parent lets it
 * shrink. Always give it flex:none in a header row.
 */
export function Seg<T extends string>({ value, options, onChange, name = 'seg' }: SegProps<T>) {
  return (
    <div className="seg" style={{ flex: 'none' }} role="group">
      {options.map((option) => (
        <label key={option.value} className="seg-opt">
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            aria-label={option.label}
          />
          <span>{option.label}</span>
          {option.count !== undefined ? (
            <span className="text-muted" style={{ fontSize: 11 }}>
              {option.count}
            </span>
          ) : null}
        </label>
      ))}
    </div>
  )
}
